import { appConfig } from '@/config/app.ts'

export interface DailyCutState {
  filters: string
}

export const initialState: DailyCutState = {
  filters: `?limit=${appConfig.pagination.defaultValue}`
}
